import type { HTMLAttributes } from 'react';
import { Text } from '@lmn/design-system';
import styled from 'styled-components';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useFetchGuestSummarizedReviews } from './hooks/useFetchGuestSummarizedReviews';
import { useTranslation } from '../translations/Translation';

export function GuestSummarizedReview(props: HTMLAttributes<HTMLElement>) {
  const { t } = useTranslation();
  const { data } = useFetchGuestSummarizedReviews();
  const { localization } = usePageWrapperData();
  const { imageBasePath } = localization;
  const { reviewsDisabled, aiSummarizedReviewsEnabled } = localization.configValuesApp;

  if (reviewsDisabled || !aiSummarizedReviewsEnabled) return undefined;

  return data?.review ? (
    <Container {...props}>
      <TitleRow>
        <img src={`${imageBasePath}hand-thumb-up.svg`} width={20} height={20} alt="" />
        <Text variant="Title5" forceTag="h3">
          {t('vacation.select.ai_summary.title')}
        </Text>
      </TitleRow>
      <Text variant="BodySmall">{data.review}</Text>
      <DisclaimerText variant="Caption">* {t('vacation.select.ai_summary.disclaimer')}</DisclaimerText>
    </Container>
  ) : undefined;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

const DisclaimerText = styled(Text)`
  color: ${(p) => p.theme.kallisto.color.text.static.textSecondary};
`;
